import type { getToken } from 'firebase/messaging'
export const MessageTypes = {
  INITIALIZE_PUSH_NOTIFICATIONS: 'INITIALIZE_PUSH_NOTIFICATIONS',
  UNREGISTER_PUSH_NOTIFICATIONS: 'UNREGISTER_PUSH_NOTIFICATIONS',
  SET_APP_ICON: 'SET_APP_ICON',
  SET_ACTIVE_PROFILE_REGULAR: 'SET_ACTIVE_PROFILE_REGULAR',
} as const
export type MessageTypes = (typeof MessageTypes)[keyof typeof MessageTypes]

export const NotificationPermission = {
  DEFAULT: 'default',
  DENIED: 'denied',
  GRANTED: 'granted',
} as const
export type NotificationPermission =
  (typeof NotificationPermission)[keyof typeof NotificationPermission]

export type Messaging = Parameters<typeof getToken>[0]
